/* ============================================
   WINDOWS NT DESKTOP — Window manager
   Pure vanilla JS. No dependencies.
   ============================================ */
(function () {
  'use strict';

  // ---------- Window Manager ----------
  const WM = {
    zCounter: 100,
    windows: {},   // id -> { el, taskEl, title }
    active: null,
  };

  function bringToFront(id) {
    const w = WM.windows[id];
    if (!w) return;
    WM.zCounter += 1;
    w.el.style.zIndex = WM.zCounter;
    // Mark active
    Object.keys(WM.windows).forEach(k => {
      WM.windows[k].el.classList.toggle('inactive', k !== id);
      if (WM.windows[k].taskEl) WM.windows[k].taskEl.classList.toggle('active', k !== id ? false : !WM.windows[k].el.classList.contains('minimized'));
    });
    WM.active = id;
  }

  function openWindow(id) {
    const w = WM.windows[id];
    if (!w) return;
    w.el.classList.remove('minimized');
    if (w.taskEl) w.taskEl.style.display = '';
    const frame = w.el.querySelector('.winnt-frame[data-src]');
    if (frame) ensureFrameLoaded(frame);
    bringToFront(id);
  }

  function closeWindow(id) {
    const w = WM.windows[id];
    if (!w) return;
    w.el.classList.add('minimized');
    if (w.taskEl) w.taskEl.classList.remove('active');
  }

  function minimizeWindow(id) {
    const w = WM.windows[id];
    if (!w) return;
    w.el.classList.add('minimized');
    if (w.taskEl) w.taskEl.classList.remove('active');
  }

  function toggleWindow(id) {
    const w = WM.windows[id];
    if (!w) return;
    if (w.el.classList.contains('minimized')) openWindow(id);
    else if (WM.active === id) minimizeWindow(id);
    else bringToFront(id);
  }

  // ---------- Drag ----------
  function makeDraggable(winEl, handleEl) {
    let startX, startY, origX, origY, dragging = false;
    handleEl.addEventListener('mousedown', e => {
      if (e.target.closest('.winnt-btn')) return;
      dragging = true;
      startX = e.clientX; startY = e.clientY;
      const rect = winEl.getBoundingClientRect();
      origX = rect.left; origY = rect.top;
      bringToFront(winEl.dataset.winid);
      e.preventDefault();
    });
    document.addEventListener('mousemove', e => {
      if (!dragging) return;
      let nx = origX + (e.clientX - startX);
      let ny = origY + (e.clientY - startY);
      nx = Math.max(0, Math.min(window.innerWidth - 60, nx));
      ny = Math.max(0, Math.min(window.innerHeight - 50, ny));
      winEl.style.left = nx + 'px';
      winEl.style.top = ny + 'px';
    });
    document.addEventListener('mouseup', () => { dragging = false; });

    // Touch fallback
    handleEl.addEventListener('touchstart', e => {
      if (e.target.closest('.winnt-btn')) return;
      const t = e.touches[0];
      dragging = true;
      startX = t.clientX; startY = t.clientY;
      const rect = winEl.getBoundingClientRect();
      origX = rect.left; origY = rect.top;
      bringToFront(winEl.dataset.winid);
    }, { passive: true });
    document.addEventListener('touchmove', e => {
      if (!dragging) return;
      const t = e.touches[0];
      winEl.style.left = (origX + t.clientX - startX) + 'px';
      winEl.style.top = (origY + t.clientY - startY) + 'px';
    }, { passive: true });
    document.addEventListener('touchend', () => { dragging = false; });
  }

  // ---------- Resize ----------
  function makeResizable(winEl) {
    const handle = document.createElement('div');
    handle.className = 'winnt-resize';
    winEl.appendChild(handle);
    let sx, sy, sw, sh, resizing = false;
    handle.addEventListener('mousedown', e => {
      resizing = true;
      sx = e.clientX; sy = e.clientY;
      sw = winEl.offsetWidth; sh = winEl.offsetHeight;
      e.preventDefault(); e.stopPropagation();
    });
    document.addEventListener('mousemove', e => {
      if (!resizing) return;
      winEl.style.width = Math.max(240, sw + e.clientX - sx) + 'px';
      winEl.style.height = Math.max(140, sh + e.clientY - sy) + 'px';
    });
    document.addEventListener('mouseup', () => { resizing = false; });
  }

  // ---------- Taskbar ----------
  function addToTaskbar(id, title, icon) {
    const tasks = document.querySelector('.winnt-tasks');
    if (!tasks) return null;
    const btn = document.createElement('button');
    btn.className = 'winnt-task';
    btn.innerHTML = `<span style="margin-right:4px">${icon}</span>${title}`;
    btn.addEventListener('click', () => toggleWindow(id));
    tasks.appendChild(btn);
    return btn;
  }

  // ---------- Window registration ----------
  function registerWindow(winEl) {
    const id = winEl.dataset.winid;
    const title = winEl.dataset.title || 'Window';
    const icon = winEl.dataset.icon || '📄';
    const titlebar = winEl.querySelector('.winnt-titlebar');
    const closeBtn = winEl.querySelector('[data-act="close"]');
    const minBtn = winEl.querySelector('[data-act="min"]');
    const maxBtn = winEl.querySelector('[data-act="max"]');

    makeDraggable(winEl, titlebar);
    makeResizable(winEl);

    const taskEl = addToTaskbar(id, title, icon);
    WM.windows[id] = { el: winEl, taskEl, title };

    if (closeBtn) closeBtn.addEventListener('click', () => closeWindow(id));
    if (minBtn) minBtn.addEventListener('click', () => minimizeWindow(id));
    if (maxBtn) maxBtn.addEventListener('click', () => {
      // Toggle maximize
      if (winEl.dataset.maxed === '1') {
        winEl.style.left = winEl.dataset.prevL;
        winEl.style.top = winEl.dataset.prevT;
        winEl.style.width = winEl.dataset.prevW;
        winEl.style.height = winEl.dataset.prevH;
        winEl.dataset.maxed = '0';
      } else {
        winEl.dataset.prevL = winEl.style.left;
        winEl.dataset.prevT = winEl.style.top;
        winEl.dataset.prevW = winEl.style.width;
        winEl.dataset.prevH = winEl.style.height;
        winEl.style.left = '0px';
        winEl.style.top = '0px';
        winEl.style.width = '100vw';
        winEl.style.height = 'calc(100vh - 28px)';
        winEl.dataset.maxed = '1';
      }
    });

    winEl.addEventListener('mousedown', () => bringToFront(id));

    // Start minimized unless data-open="1"
    if (winEl.dataset.open !== '1') {
      winEl.classList.add('minimized');
    } else {
      bringToFront(id);
    }
  }

  // ---------- Image viewer (dynamic windows) ----------
  let viewerCount = 0;
  function openImageViewer(src, caption) {
    viewerCount += 1;
    const id = 'viewer-' + viewerCount;
    const win = document.createElement('div');
    win.className = 'winnt-window';
    win.dataset.winid = id;
    win.dataset.title = caption || 'Image Viewer';
    win.dataset.icon = '🖼️';
    win.dataset.open = '1';
    win.style.left = (80 + viewerCount * 24) + 'px';
    win.style.top = (80 + viewerCount * 24) + 'px';
    win.style.width = '480px';
    win.style.height = '380px';
    win.innerHTML = `
      <div class="winnt-titlebar">
        <div class="winnt-title">🖼️ ${escapeHtml(caption || 'Image Viewer')}</div>
        <div class="winnt-title-controls">
          <button class="winnt-btn" data-act="min">_</button>
          <button class="winnt-btn" data-act="max">▢</button>
          <button class="winnt-btn" data-act="close">✕</button>
        </div>
      </div>
      <div class="winnt-window-body" style="padding:0;background:#000">
        <div class="winnt-viewer"><img src="${src}" alt="${escapeHtml(caption || '')}"></div>
      </div>
    `;
    document.querySelector('.winnt-desktop').appendChild(win);
    registerWindow(win);
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, c => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[c]));
  }

  // ---------- Frame loader (replaces iframe to avoid X-Frame-Options) ----------
  function appendView(url) {
    if (!url) return url;
    if (url.indexOf('://') !== -1 || url.indexOf('//') === 0) return url; // external
    if (url.indexOf('view=desktop-window') !== -1) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'view=desktop-window';
  }

  function ensureFrameLoaded(frame) {
    if (!frame || frame.dataset.loaded === '1' || frame.dataset.loading === '1') return;
    loadFrame(frame, frame.dataset.src);
  }

  function showPhoto(g, thumbs, i) {
    const img = g.querySelector('.winnt-product-main-img');
    thumbs.forEach((t, k) => t.classList.toggle('active', k === i));
    if (img) img.src = thumbs[i].dataset.fullSrc;
    const c = g.querySelector('.winnt-gallery-current');
    if (c) c.textContent = String(i + 1);
  }

  function bindFrameEvents(frame) {
    if (!frame || frame.dataset.bound === '1') return;
    frame.dataset.bound = '1';

    // Product photo gallery
    frame.addEventListener('click', e => {
      const g = e.target.closest('[data-product-gallery]');
      if (!g) return;
      const thumbs = Array.from(g.querySelectorAll('.winnt-product-thumb'));
      if (!thumbs.length) return;
      let cur = Math.max(0, thumbs.findIndex(t => t.classList.contains('active')));
      let next = null;
      const t = e.target.closest('.winnt-product-thumb');
      if (t) next = thumbs.indexOf(t);
      else if (e.target.closest('.winnt-gallery-prev')) next = (cur - 1 + thumbs.length) % thumbs.length;
      else if (e.target.closest('.winnt-gallery-next')) next = (cur + 1) % thumbs.length;
      if (next === null) return;
      showPhoto(g, thumbs, next);
    });
    frame.addEventListener('change', e => {
      if (!e.target || e.target.name !== 'id' || !e.target.options) return;
      const opt = e.target.options[e.target.selectedIndex];
      const id = opt && opt.getAttribute('data-media-id');
      const g = frame.querySelector('[data-product-gallery]');
      if (!id || !g) return;
      const thumbs = Array.from(g.querySelectorAll('.winnt-product-thumb'));
      const i = thumbs.findIndex(t => t.dataset.mediaId === id);
      if (i !== -1) showPhoto(g, thumbs, i);
    });

    // Intercept internal link clicks to navigate within this window
    frame.addEventListener('click', e => {
      const a = e.target.closest('a[href]');
      if (!a) return;
      const href = a.getAttribute('href');
      if (!href || href.charAt(0) === '#') return;
      if (a.target === '_blank') return;
      if (href.indexOf('://') !== -1 || href.indexOf('//') === 0) return;
      if (href.indexOf('/checkout') === 0) {
        try { window.top.location.href = href; } catch (_) { window.location.href = href; }
        e.preventDefault();
        return;
      }
      e.preventDefault();
      loadFrame(frame, href);
    });

    // Keep Shopify cart/product form actions inside the desktop window where possible.
    frame.addEventListener('submit', async e => {
      const form = e.target.closest('form');
      if (!form) return;
      const action = form.getAttribute('action') || window.location.pathname;
      const isCartAction = action.indexOf('/cart') === 0;
      if (!isCartAction) return;
      e.preventDefault();
      const submitter = e.submitter;
      const returnToCheckout = submitter && submitter.name === 'return_to' && submitter.value && submitter.value.indexOf('/checkout') === 0;
      try {
        const formData = new FormData(form);
        if (submitter && submitter.name) formData.set(submitter.name, submitter.value || '');
        const response = await fetch(action, {
          method: (form.getAttribute('method') || 'POST').toUpperCase(),
          body: formData,
          credentials: 'same-origin',
          headers: { 'Accept': 'text/html' },
        });
        if (!response.ok) throw new Error('HTTP ' + response.status);
        if (returnToCheckout) {
          try { window.top.location.href = '/checkout'; } catch (_) { window.location.href = '/checkout'; }
          return;
        }
        loadFrame(frame, '/cart');
      } catch (err) {
        frame.innerHTML = '<div style="padding:20px;color:#a00">Shop action failed.<br><small>' + escapeHtml(err.message || String(err)) + '</small></div>';
      }
    });
  }

  async function loadFrame(frame, url) {
    const fetchUrl = appendView(url);
    bindFrameEvents(frame);
    frame.dataset.loading = '1';
    frame.innerHTML = '<div style="padding:20px;text-align:center;color:#666">Loading…</div>';
    try {
      const r = await fetch(fetchUrl, { credentials: 'same-origin', headers: { 'Accept': 'text/html' } });
      if (!r.ok) throw new Error('HTTP ' + r.status);
      const html = await r.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const body = doc.body ? doc.body.innerHTML : html;
      frame.innerHTML = body;
      // Run any inline scripts that came with the fetched HTML
      frame.querySelectorAll('script').forEach(old => {
        const s = document.createElement('script');
        for (const a of old.attributes) s.setAttribute(a.name, a.value);
        s.text = old.textContent;
        old.parentNode.replaceChild(s, old);
      });
      frame.dataset.src = url;
      frame.dataset.loaded = '1';
    } catch (err) {
      frame.innerHTML = '<div style="padding:20px;color:#a00">Could not load <code>' + escapeHtml(url) + '</code><br><small>' + escapeHtml(err.message || String(err)) + '</small></div>';
    } finally {
      delete frame.dataset.loading;
    }
  }

  // ---------- Init ----------
  document.addEventListener('DOMContentLoaded', init);
  function init() {
    const root = document.querySelector('.winnt-root');
    if (!root) return;

    // Register all windows
    document.querySelectorAll('.winnt-window').forEach(registerWindow);

    // Only load the windows that start open. Other windows load on first open.
    document.querySelectorAll('.winnt-window[data-open="1"] .winnt-frame[data-src]').forEach(ensureFrameLoaded);

    // Desktop icons -> open windows
    document.querySelectorAll('.winnt-icon').forEach(icon => {
      const target = icon.dataset.target;
      icon.addEventListener('dblclick', () => openWindow(target));
      let lastTap = 0;
      icon.addEventListener('click', () => {
        document.querySelectorAll('.winnt-icon').forEach(i => i.classList.remove('selected'));
        icon.classList.add('selected');
        const now = Date.now();
        if (now - lastTap < 400) openWindow(target);
        lastTap = now;
      });
    });

    // Portfolio thumbs -> image viewer
    document.querySelectorAll('[data-viewer-src]').forEach(thumb => {
      thumb.addEventListener('click', () => {
        openImageViewer(thumb.dataset.viewerSrc, thumb.dataset.viewerTitle || '');
      });
    });

    // Start menu
    const startBtn = document.querySelector('.winnt-start');
    const startMenu = document.querySelector('.winnt-start-menu');
    if (startBtn && startMenu) {
      startBtn.addEventListener('click', e => {
        e.stopPropagation();
        startMenu.classList.toggle('open');
        startBtn.classList.toggle('active');
      });
      document.addEventListener('click', e => {
        if (!startMenu.contains(e.target) && e.target !== startBtn) {
          startMenu.classList.remove('open');
          startBtn.classList.remove('active');
        }
      });
      startMenu.querySelectorAll('[data-target]').forEach(item => {
        item.addEventListener('click', () => {
          openWindow(item.dataset.target);
          startMenu.classList.remove('open');
          startBtn.classList.remove('active');
        });
      });
    }

    // Clock
    const clock = document.querySelector('.winnt-clock');
    if (clock) {
      function tick() {
        const d = new Date();
        let h = d.getHours(); const m = d.getMinutes();
        const ampm = h >= 12 ? 'PM' : 'AM';
        h = h % 12 || 12;
        clock.textContent = `${h}:${m.toString().padStart(2, '0')} ${ampm}`;
      }
      tick(); setInterval(tick, 30000);
    }

    // Click empty desktop -> deselect
    document.querySelector('.winnt-desktop').addEventListener('mousedown', e => {
      if (e.target.classList.contains('winnt-desktop')) {
        document.querySelectorAll('.winnt-icon').forEach(i => i.classList.remove('selected'));
      }
    });

    // Commission form -> Formspree (configure endpoint via data attr)
    const form = document.querySelector('.winnt-commission-form');
    if (form) {
      form.addEventListener('submit', async e => {
        const endpoint = form.dataset.endpoint;
        if (!endpoint || endpoint.indexOf('REPLACE_ME') !== -1) {
          e.preventDefault();
          alert('Form not configured. Set data-endpoint on the form to your Formspree URL.');
          return;
        }
        // Allow native submission to Formspree, OR use AJAX:
        e.preventDefault();
        const data = new FormData(form);
        try {
          const r = await fetch(endpoint, { method: 'POST', body: data, headers: { Accept: 'application/json' } });
          if (r.ok) { alert('Message sent! ✓'); form.reset(); }
          else alert('Send failed. Please try again.');
        } catch (err) { alert('Network error.'); }
      });
    }
  }

  // Expose globally for Shopify Buy Button hooks etc.
  window.WinNT = { open: openWindow, close: closeWindow, minimize: minimizeWindow, openImageViewer };
})();
